import React, { useState } from "react";
import AdminTable from "../../components/Admin/AdminTable";
import "../../styles/Admin.css";

const VisibilityTable = ({ rules, onEnable, loading }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [filterType, setFilterType] = useState("all");

  // Only show disabled rules (hidden from users)
  const disabledRules = rules.filter((rule) => rule.disabled);

  const filteredRules = disabledRules.filter((rule) => {
    const matchesSearch = 
      rule.identifier.toLowerCase().includes(searchTerm.toLowerCase()) ||
      rule.type.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesFilter = filterType === "all" || rule.type === filterType;
    return matchesSearch && matchesFilter;
  });

  const columns = [
    { key: "type", label: "Type" },
    { key: "identifier", label: "Identifier" },
    {
      key: "created_at",
      label: "Disabled On",
      render: (value) => (value ? new Date(value).toLocaleString() : "-"),
    },
  ];

  const actions = (row) => (
    <button
      className="btn-primary admin-action-btn"
      onClick={() => onEnable && onEnable(row)}
      title="Enable this resource for users"
    >
      Enable
    </button>
  );

  return (
    <div className="admin-section">
      <div className="admin-section-header">
        <h3 className="admin-section-title">Currently Disabled Resources</h3>
        <p className="text-muted" style={{ fontSize: 12, marginTop: 8 }}>
          These resources are hidden from users. Enable them to make them available again.
        </p>
      </div>

      {filteredRules.length > 0 && (
        <div className="admin-search">
          <input
            type="text"
            className="form-control"
            placeholder="Search by identifier or type..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <select
            className="form-control"
            style={{ width: "auto", minWidth: 150 }}
            value={filterType}
            onChange={(e) => setFilterType(e.target.value)}
          >
            <option value="all">All Types</option>
            <option value="region">Region</option>
            <option value="os">OS</option>
            <option value="app">App</option>
          </select>
        </div>
      )}

      <AdminTable
        columns={columns}
        data={filteredRules}
        actions={actions}
        loading={loading}
        emptyMessage="No disabled resources. All resources are currently available to users."
      />
    </div>
  );
};

export default VisibilityTable;

